<template>
<div>
    <div v-if="!add">
        <button style="float: right" @click="gestorAdd">Add</button>
        <div v-if="tipo === 'cuenta'">
            <div v-for="item in allCuentaContacto" :key="item.id">
                {{item.razonsocial}}
            </div>
        </div>
        <div v-else>
            <div v-for="item in allContactoCuenta" :key="item.id">
                {{item.nombre}}
            </div>
        </div>
    </div>
    <div v-else>
        <button style="float: right" @click="save">Add</button>
        <div class="row mt-3">
            <div class="col-md-6">
                <h4>Agregar</h4>
                <div v-if="tipo === 'cuenta'">
                    <div v-for="item in allCuentas" :key="item.id">
                        <span @click="agregar(item)">-{{item.razonsocial}}</span> 
                    </div>
                </div>
                <div v-else>
                    <div v-for="item in allContacto" :key="item.id">
                        <span @click="agregar(item)">-{{item.nombre}}</span> 
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h4>Nuevo</h4>
                <div v-for="item in arrayAdd" :key="item.id">
                   <span @click="agregar(item)">-{{tipo === 'cuenta' ? item.razonsocial : item.nombre}}</span> 
                </div>
            </div>
        </div>
        
    </div>
</div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    props:{
        tipo: {
            type: String,
            default: false
        },
        data: {
            type: Array
        }
    },
    data() {
        return {
            add: false,
            arrayAdd:[]
        }
    },
    computed: {
        ...mapGetters('validatetoken', 
        { 
            allCuentas: 'allCuentas' ,
            allCuentaContacto: 'allCuentaContacto',
            allContactoCuenta: 'allContactoCuenta',
            allContacto: 'allContacto'
           
        })
    },
    methods: {
        ...mapActions('validatetoken', { getAllCuentas: 'getAllCuentas', getContacto: 'getContacto', saveContacto:'saveContacto', saveCuenta: 'saveCuenta'}),
        getAll(tipo){

            switch (tipo) {
                case 'cuenta':
                    this.getAllCuentas({pagina:1, cantidad: 10})
                    .then((data)=>{
                         this.$store.commit('validatetoken/setAllCuenta', data)
                    })
                    break;

                    case 'contacto':
                    this.getContacto({pagina:1, cantidad: 10})
                    .then((data)=>{
                         this.$store.commit('validatetoken/setAllContacto', data)
                    })
                    break;
            
                default:
                    break;
            }
        },
        gestorAdd(){
            this.add = !this.add
        },
        agregar(item){
            let cuenta
            
            if (this.tipo === 'cuenta'){
                cuenta = this.allCuentas.findIndex(a => a.id == item.id)
                 if (cuenta > -1){
                    this.allCuentas.splice(cuenta, 1)
                    this.arrayAdd.push(item)
                } 
            }else {
                cuenta = this.allContacto.findIndex(a => a.id == item.id)
                if (cuenta > -1){
                    this.allContacto.splice(cuenta, 1)
                    this.arrayAdd.push(item)
                } 
            }

           
        },
        save(){
            // console.log(this.$store.state.validatetoken.oneContacto.grupocuentas)
            let array = []
            for (let i of this.arrayAdd){
                array.push(i.id)
            }

            if (this.tipo === 'cuenta'){
                array = [
                    ...array,
                    ...this.$store.state.validatetoken.oneContacto.grupocuentas
                ]
                this.saveContacto({
                    grupocuentas: array
                })
                .then(()=>{
                        this.getAllCuentas({
                        listaids: array.join()
                    })
                    .then((data)=>{
                        this.add = !this.add
                        this.$store.commit('validatetoken/setAllCuentaContacto', data)
                    })
                })
            } else {
                  array = [
                    ...array,
                    ...this.$store.state.validatetoken.oneCuenta.grupocontactos
                ]

                this.saveCuenta({
                    grupocontactos: array
                })
               .then(()=>{
                    this.getContacto({
                        listaids: array.join()
                    })
                    .then((data)=>{
                         this.add = !this.add
                        this.$store.commit('validatetoken/setAllContactoCuenta', data)
                    })
                })
            }
        }
    },
    created(){
        this.getAll(this.tipo)
    }

}
</script>

<style>

</style>